import { render, staticRenderFns } from "./UniFormView.vue?vue&type=template&id=30239b64&scoped=true"
import script from "./UniFormView.vue?vue&type=script&lang=ts"
export * from "./UniFormView.vue?vue&type=script&lang=ts"
import style0 from "./UniFormView.vue?vue&type=style&index=0&id=30239b64&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.0.10@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30239b64",
  null
  
)

export default component.exports